'use client'

import useIsMobile from '@/hooks/useIsMobile'
import { GoalProps } from '@/widgets/landing-page-widgets/hero-section/schema'
import { SpeakerWaveIcon, SpeakerXMarkIcon } from '@heroicons/react/24/solid'
import Image from 'next/image'
import { useRef, useState } from 'react'
import { FALLBACK_IMAGE } from '../../contants'
import styles from './styles.module.css'

const BookDemoStep = ({ goal }: { goal?: GoalProps }) => {
  const { isMobile } = useIsMobile()
  const videoBannerRef = useRef<HTMLVideoElement>(null)
  const [isMuted, setIsMuted] = useState<boolean>(true)
  const [isInitialPlay, setIsInitialPlay] = useState<boolean>(true)

  const handleSpeakerClick = () => {
    if (typeof window === 'undefined') return

    if (isMuted && isInitialPlay) {
      setIsInitialPlay(false)
      if (videoBannerRef.current) {
        videoBannerRef.current.pause()
        videoBannerRef.current.currentTime = 0
        const playPromise = videoBannerRef.current.play()
        
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            if (error.name === 'NotAllowedError') {
              console.log('Video autoplay prevented - user interaction required')
            } else {
              console.error('Error playing video:', error)
            }
          })
        }
      }
    }

    setIsMuted(prev => !prev)
  }

  if (goal?.showVideoBanner && goal?.videoBannerUrl && goal?.mwebvideoBannerUrl) {
    return (
      <div className='relative overflow-hidden'>
        <video
          src={isMobile ? goal?.mwebvideoBannerUrl : goal.videoBannerUrl}
          playsInline
          id='banner-video'
          autoPlay
          ref={videoBannerRef}
          loop
          muted={isMuted}
          className='w-full h-full object-fill'
        >
        </video>

        <div className={`${styles.speakerButton} border-white bg-black100 p-1 bottom-4 right-4`} onClick={handleSpeakerClick}>
          {!isMuted ? (
            <SpeakerWaveIcon className='h-6 w-6' fill='white' strokeWidth='2px' />
          ) : (
            <SpeakerXMarkIcon className='h-6 w-6' fill='white' strokeWidth='2px' />
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={styles.imageContainer}>
      <Image src={goal?.webBanner ?? FALLBACK_IMAGE} alt='banner' fill style={{ objectFit: 'cover' }} />
    </div>
  )
}

export default BookDemoStep
